// in split view, we need new breakpoints for screen sizes
// due to low browser support for container queries, we just use screen breakpoints
export const SPLIT_VIEW_BREAKPOINTS = {
  medium: 1125,
  large: 1375,
} as const
